export default __webpack_public_path__ + "8420d69ff6cbe613d0bc1538aa69f4ce.svg";